import policy from '../modules/policy/locales/en.json';
import waComponents from './wa-components.json';
import banner from '../modules/banners/locales/en.json';

const combined = {
  ...policy,
  ...waComponents,
  ...banner,
};

export default combined;
